/* eslint-disable react/prop-types */

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";

export default function AccountingTable7() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <h1>Bảng Kê Số 7</h1>
    </DashboardLayout>
  );
}
